import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const unitWiseUserList = createAsyncThunk('unitWiseUser/list', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `unit_wise_user/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addVacateUnit = createAsyncThunk('vacateUnit/add', async (data) => {

    var documents = data?.values?.documents?.map((item) => (
        { documents_name: item?.name, documents_file: item?.file }
    ))

    var bodyFormData = new FormData()

    bodyFormData.append("premise_id", data?.values?.premise)
    bodyFormData.append("zone_id", data?.values?.zone)
    bodyFormData.append("level_id", data?.values?.level)
    bodyFormData.append("unit_id", data?.values?.unit)
    bodyFormData.append("unit_assign_id", data?.values?.user)
    bodyFormData.append("end_date", data?.values?.end_date && moment(data?.values?.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("checklist", JSON.stringify(data?.values?.checklist))
    bodyFormData.append("documents", JSON.stringify(documents))

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'unit_vacate',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const vacateUnit = createSlice({
    name: 'vacateUnit',
    initialState: {
        unitWiseUser: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(unitWiseUserList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(unitWiseUserList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.unitWiseUser = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.unitWiseUser = []
            }
        });
        builder.addCase(unitWiseUserList.rejected, (state, action) => {
            state.loading = false;
        })
    }
})

export default vacateUnit.reducer;